import React, { useState } from "react";
import {
  Grid,
  Typography,
  TextField,
  CircularProgress,
  IconButton,
  FormGroup,
  FormControlLabel,
  Switch,
  Box,
} from "@material-ui/core";
import { PrimaryButton } from "src/Shared/Buttons";
import axios from "axios";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { FileCopy } from "@material-ui/icons";
import { useSelector } from "react-redux";

const GeneralSettingsBasic = ({
  classes,
  settings,
  setSettings,
  handleSnackbarOpen,
}) => {
  const { restaurantData } = useSelector((state) => state.Restaurant);
  const history = useHistory();
  const restId = history?.location?.pathname?.split("/")[2];
  const customerPanel = process.env.REACT_APP_CUSTOMER_PATH;
  const apiUrl = process.env.REACT_APP_API_URL;
  const [existedSlug, setExistedSlug] = useState("");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({
    email: false,
    phone: false,
    rest_name: false,
    Altphone: false,
    slug: {
      success: false,
      err: false,
      message: "",
    },
  });
  const redirectLink = {
    fontSize: "15px",
    cursor: "pointer",
    textDecoration: "underline",
    color: "blue",
    marginTop: "30px",
  };

  useEffect(() => {
    if (restaurantData && restId) {
      let currentRest = restaurantData.find(
        (restData) => restData.id === restId
      );

      setExistedSlug(currentRest?.slug || "");
    }
  }, [restaurantData, restId]);

  const handleChange = (e) => {
    let { name, value } = e.target;
    let regex = /^[a-z0-9_-]+$/i;
    if (name === "slug" && value.length !== 0 && !regex.test(value)) {
      return;
    }
    let obj = settings.generalSettings;
    name === "kitchenhub_store_id"
      ? (obj[name] = value)
      : (obj.basic[name] = value);
    setSettings({ ...settings, generalSettings: obj });
    validate(name, value);
  };
  const handlephone = (e) => {
    let { name, value } = e.target;
    let obj = settings.generalSettings;
    obj.basic[name] = value;
    setSettings({ ...settings, generalSettings: obj });
    validate(name, value);
  };
  const handleAlternateContactHide = async ()=>{
    let newObj = {...settings.generalSettings}
    newObj.basic.hide_alternate_number = !settings.generalSettings.basic.hide_alternate_number
    await setSettings({ ...settings, generalSettings: newObj })
 }

  const validate = (name, value) => {
    const regex = /^([a-z\d\.-]+)@([a-z\d-]+)\.([a-z]{2,8})(\.[a-z]{2,8})?$/;
    const regex2 = /^[0-9+-]{10,15}$/;
    const regex3 = /^[0-9!@#$%^&*()_+{}\[\]:;<>,.?~\\/\-\s]+$/;
    let errs = errors;
    switch (name) {
      case "restaurant_name":
        if (value.length < 2) {
          errs.rest_name = true;
        } else {
          errs.rest_name = false;
        }
        break;
      case "email_id":
        if (!regex.test(value)) {
          errs.email = true;
        } else {
          errs.email = false;
        }
        break;
      case "phone_number":
        if (!regex2.test(value)) {
          errs.phone = true;
        } else {
          errs.phone = false;
        }
        break;
      case "alternate_contact_number":
        if (!regex3.test(value)) {
          errs.Altphone = true;
        } else {
          errs.Altphone = false;
        }
        break;
      default:
        break;
    }
    errs.slug = { message: "", err: false, success: false };
    setErrors(errs);
  };
  const handleRedirect = () => {
    window.open(`${customerPanel}/${settings?.generalSettings?.basic?.slug}`);
  };
  const checkSlugAvailabilityHanlder = async () => {
    if (existedSlug === settings?.generalSettings?.basic?.slug) {
      setErrors({
        ...errors,
        slug: { success: true, message: "You already have this slug!" },
      });
      return;
    }
    setErrors({
      ...errors,
      slug: { err: false, message: "" },
    });
    if (
      !settings?.generalSettings?.basic?.slug ||
      typeof settings?.generalSettings?.basic?.slug !== "string" ||
      settings?.generalSettings?.basic?.slug.length < 1
    ) {
      setErrors({
        ...errors,
        slug: {
          err: true,
          message: "Invalid Slug!",
        },
      });
      return;
    } else {
      setLoading(true);
      try {
        const res = await axios.post(`${apiUrl}slug/isAvailable`, {
          slug: settings?.generalSettings?.basic?.slug,
        });
        if (res?.data) {
          const { is_available, restaurant_id } = res.data;
          if (!is_available) {
            if (restaurant_id === restId) {
              setErrors({
                ...errors,
                slug: { success: true, message: "You already have this slug!" },
              });
              return;
            }
            setErrors({
              ...errors,
              slug: { err: true, message: "Slug is not available!" },
            });
          } else {
            setErrors({
              ...errors,
              slug: { success: true, message: "Slug is available!" },
            });
          }
          return;
        }
        throw new Error("Something went wrong!");
      } catch (error) {
        if (error?.response?.data?.error) {
          setErrors({
            ...errors,
            slug: { err: true, message: error?.response?.data?.error },
          });
          return;
        } else if (error?.message) {
          setErrors({
            ...errors,
            slug: { err: true, message: error?.message },
          });
        }
      } finally {
        setLoading(false);
      }
      return;
    }
  };

  // const handleContactHide = async () => {
  //   let newObj = { ...settings.generalSettings };
  //   newObj.basic.hide_number = !settings.generalSettings.basic.hide_number;
  //   await setSettings({ ...settings, generalSettings: newObj });
  //   console.log("settings", settings);
  // };

  const copyhandler = () => {
    window.navigator.clipboard.writeText(`${customerPanel}/${existedSlug}`);
    handleSnackbarOpen("Copied to clipboard", "successDark");
  };
  return (
    <>
      <Grid item xs={12}>
        <Typography variant="h5" className={classes.typographyStyles}>
          General Settings
        </Typography>
        <hr />
      </Grid>
      <Grid item xs={12} sm={2} className={classes.mt30}>
        <Typography variant="body1" className={classes.typographyStyles}>
          Restaurant Name
        </Typography>
      </Grid>
      <Grid item xs={12} sm={4} className={classes.mt20}>
        <TextField
          className={classes.textFieldStyles}
          fullWidth
          variant="outlined"
          size="small"
          name="restaurant_name"
          value={settings?.generalSettings?.basic?.restaurant_name || ""}
          onChange={handleChange}
          error={errors.rest_name}
          helperText={errors.rest_name && "Invalid Input!"}
          inputProps={{
            "aria-label": "rest_name_input",
          }}
        />
      </Grid>
      <Grid item xs={false} sm={6} />
      <Grid item xs={12} sm={2} className={classes.mt30}>
        <Typography variant="body1" className={classes.typographyStyles}>
          Email Id
        </Typography>
      </Grid>
      <Grid item xs={12} sm={4} className={classes.mt20}>
        <TextField
          className={classes.textFieldStyles}
          type="email"
          fullWidth
          variant="outlined"
          size="small"
          name="email_id"
          value={settings?.generalSettings?.basic?.email_id || ""}
          onChange={handleChange}
          error={errors.email}
          helperText={errors.email && "Invalid Email!"}
          inputProps={{
            "aria-label": "email_id_input",
          }}
        />
      </Grid>
      <Grid item xs={false} sm={6} />
      <Grid item xs={12} sm={2} className={classes.mt30}>
        <Typography variant="body1" className={classes.typographyStyles}>
          Slug
        </Typography>
      </Grid>
      <Grid item xs={12} sm={4} className={classes.mt20}>
        <TextField
          className={classes.textFieldStyles}
          type="text"
          fullWidth
          variant="outlined"
          size="small"
          name="slug"
          value={settings?.generalSettings?.basic?.slug || ""}
          onChange={handleChange}
          error={errors.slug.err}
          helperText={
            (errors.slug.err || errors.slug.success) && errors.slug.message
          }
          inputProps={{
            "aria-label": "slug_input",
          }}
        />
      </Grid>
      <Grid xs={false} sm={1} />
      <Grid item xs={12} sm={4} className={classes.mt20}>
        <PrimaryButton
          type="success"
          handleClick={checkSlugAvailabilityHanlder}
          testId={`check_slug_availability_btn`}
        >
          {loading ? <CircularProgress size={20} /> : "Check Availability"}
        </PrimaryButton>
      </Grid>
      <Grid xs={false} sm={1} />
      <Grid item xs={12} sm={2} className={classes.mt30}>
        <Typography variant="body1" className={classes.typographyStyles}>
          Phone Number
        </Typography>
      </Grid>
      <Grid
        item
        xs={12}
        style={{ display: "flex" }}
        sm={4}
        className={classes.mt20}
      >
        <Grid item xs={5}>
          <TextField
            className={classes.textFieldStyles}
            fullWidth
            variant="outlined"
            size="small"
            name="phone_number"
            value={settings?.generalSettings?.basic?.phone_number || ""}
            onChange={handleChange}
            error={errors.phone}
            helperText={errors.phone && "Invalid Number!"}
            inputProps={{
              "aria-label": "phone_number_input",
            }}
          />
        </Grid>
        {/* switch */}
        {/* <Grid item xs={5}>
          <FormGroup className={classes.ml20}>
            <FormControlLabel
              control={
                <Switch
                  checked={!settings?.generalSettings?.basic?.hide_number}
                  onChange={(e) => {
                    handleContactHide(e);
                  }}
                />
              }
              label={
                settings?.generalSettings?.basic?.hide_number ? (
                  <Typography color="primary"> Hidden </Typography>
                ) : (
                  <Typography color="primary"> Visible </Typography>
                )
              }
            />
          </FormGroup>
        </Grid> */}
        {/* switch */}
      </Grid>
      <Grid item xs={false} sm={6} />
      {/* <Grid xs={false} sm={1} /> */}
      <Grid item xs={12} sm={2} className={classes.mt30}>
        <Typography variant="body1" className={classes.typographyStyles}>
          Display Number
        </Typography>
      </Grid>
      <Grid
        item
        xs={12}
        style={{ display: "flex" }}
        sm={4}
        className={classes.mt20}
      >
        <Grid item xs={5}>
          <TextField
            className={classes.textFieldStyles}
            fullWidth
            variant="outlined"
            size="small"
            name="alternate_contact_number"
            value={settings?.generalSettings?.basic?.alternate_contact_number || ""}
            onChange={handlephone}
            error={errors.Altphone}
            helperText={errors.Altphone && "Invalid Number!"}
            inputProps={{
              "aria-label": "phone_number_input",
            }}
          />
        </Grid>
        {/* switch */}
        <Grid item xs={5}>
          <FormGroup className={classes.ml20}>
            <FormControlLabel
              control={
                <Switch
                  checked={!settings?.generalSettings?.basic?.hide_alternate_number}
                  onChange={(e) => {
                    handleAlternateContactHide(e);
                  }}
                />
              }
              label={
                settings?.generalSettings?.basic?.hide_alternate_number ? (
                  <Typography color="primary"> Hidden </Typography>
                ) : (
                  <Typography color="primary"> Visible </Typography>
                )
              }
            />
          </FormGroup>
        </Grid>
        {/* switch */}
      </Grid>
      <Grid item xs={false} sm={6} />
      <Grid item xs={12} sm={2} className={classes.mt30}>
        <Typography variant="body1" className={classes.typographyStyles}>
          Kitchen Hub Store Id
        </Typography>
      </Grid>
      <Grid item xs={12} sm={4} className={classes.mt20}>
        <TextField
          className={classes.textFieldStyles}
          fullWidth
          variant="outlined"
          size="small"
          name="kitchenhub_store_id"
          value={settings?.generalSettings?.kitchenhub_store_id || ""}
          onChange={handleChange}
          // error={errors.phone}
          // helperText={errors.phone && "Invalid Number!"}
          inputProps={{
            "aria-label": "kitchenhub_store_id",
          }}
        />
      </Grid>
      <Grid item xs={false} sm={6} />
      <Grid item xs={6} sm={5} lg={2}>
        <p onClick={handleRedirect} style={redirectLink}>
          {`${customerPanel}/${settings?.generalSettings?.basic?.slug}`}
        </p>
      </Grid>{" "}
      <Grid item xs={1} sm={false} />
      <Grid item xs={2} sm={2} lg={1} style={{ marginTop: "15px" }}>
        <IconButton onClick={() => copyhandler()}>
          <FileCopy />
        </IconButton>
      </Grid>
      <Grid item xs={3} sm={5} lg={9} />
    </>
  );
};

export default GeneralSettingsBasic;
